import {DEFAULT_TIME_ZONE} from '../common/constants'

import {usePlant} from './usePlant'

export const usePlantTimeZone: () => string = () => {
  const plant = usePlant()
  return plant?.timeZone ?? DEFAULT_TIME_ZONE
}
